import vars from '../helpers';
import Scrollbar from 'smooth-scrollbar';
import analytics from './analytics';
const scrollContainer = vars.$document[0].querySelector('.js-scroller');
let progressFixed = 0;
let scrollPercent = 0;
let scrollbar = null;
const $scroller = vars.$document.find('.js-scroller');
let lastScroll = vars.$document.find('.header').height() + 10;

const showElementsOnScroll = ($elements) => {
	const scrollTop = vars.$window.scrollTop();
	// const scrollBottom = scrollTop + innerHeight;
	const $videoArticlePage = vars.$document.find('.js-article-video');

	$elements
		.filter(':visible')
		.each((_, element) => {
			const $element = $(element);

			const elementOffsetTop = $element.offset().top;
			const elementOffsetBottom = elementOffsetTop + $element.outerHeight();

			if (scrollTop <= elementOffsetBottom && elementOffsetTop > lastScroll) {
				$videoArticlePage.removeClass('is-hidden');
			}

			lastScroll = elementOffsetTop;
		});
};

function listenerAnalytic(status) {
	const Y = status.offset.y;
	scrollPercent = parseInt(100 * (Y + vars.$window.outerHeight()) / $scroller.find('.scroll-content').innerHeight(), 10);

	if (progressFixed !== 100) {
		if (scrollPercent >= 25 && scrollPercent < 50 && progressFixed !== 25) {
			progressFixed = 25;
			analytics.progress(25);
		} else if (scrollPercent >= 50 && scrollPercent < 75 && progressFixed !== 50) {
			progressFixed = 50;
			analytics.progress(50);
		} else if (scrollPercent >= 75 && scrollPercent < 99 && progressFixed !== 75) {
			progressFixed = 75;
			analytics.progress(75);
		} else if (scrollPercent >= 99 && progressFixed !== 100) {
			progressFixed = 100;
			analytics.progress(100);
		}
	}
}

function analyticScrollReset() {
	progressFixed = 0;
	scrollPercent = 0;
}

function init(container) {
	const $showOnScrollElements = $(container).find('.js-section-1');

	scrollbar = Scrollbar.init(scrollContainer, {
		damping: 0.1,
		renderByPixels: true,
		alwaysShowTracks: false,
		syncCallbacks: true,
	});

	scrollbar.addListener(listenerAnalytic);
	scrollbar.addListener(() => {
		showElementsOnScroll($showOnScrollElements);
	});

	return scrollbar;
}

function destroy() {
	if (scrollbar) {
		scrollbar.destroy();
		$(scrollContainer)
			.removeAttr('data-scrollbar tabindex style');
		scrollbar.removeListener(listenerAnalytic);
		scrollbar = null;
	}
}

export default {
	init,
	destroy,
	analyticScrollReset,
};
